import { OptionModalProps } from ".";
import { useState } from "react";
import ListEditor, { ListEditTableDescription } from "./listEditor";
import { CoreModal, CorePaper, CoreTitleCard } from "../../../core";
import { useMobileLayout } from "../../../hooks";
import { ProctoringOption } from "@verity/proctoring-option/types";
import i18nPackage from "../../../i18n/i18n";

export default function ExcludedWebTrafficRecordingUrlsList<T extends Partial<ProctoringOption>>({
	onClose,
	currOption,
	updateOption,
}: OptionModalProps<T>) {
	const { excludedWebTrafficRecordingUrls } = currOption;
	const [excludedUrls, setExcludedUrls] = useState(excludedWebTrafficRecordingUrls ?? []);
	const isMobileLayout = useMobileLayout();

	const onSave = () => {
		const uniqueList = Array.from(new Set(excludedUrls.map((url) => url.trim())));
		updateOption({
			...currOption,
			excludedWebTrafficRecordingUrls: uniqueList,
		});
		onClose();
	};

	const content = (
		<ListEditor
			currList={excludedUrls}
			updateList={setExcludedUrls}
			placeholder={i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.placeholder")}
			emptyText={i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.emptyText")}
		/>
	);

	return (
		<CoreModal
			open
			onClose={onClose}
			title={
				isMobileLayout
					? undefined
					: i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.title")
			}
			minWidth={isMobileLayout ? undefined : "min(65%, 700px)"}
			widthFixed
			heightFixed={isMobileLayout}
			fullScreen={isMobileLayout}
			showTopCloseButton={!isMobileLayout}
			dialogContentBackground={isMobileLayout ? "#f4f4f4" : undefined}
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.cancel"),
					color: "secondary",
					style: { marginLeft: isMobileLayout ? "auto" : undefined },
					onClick: onClose,
				},
				{
					text: i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.save"),
					color: "primary",
					onClick: onSave,
				},
			]}
		>
			{isMobileLayout ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						width: "100%",
						gap: "10px",
						background: "#f4f4f4",
					}}
				>
					<CoreTitleCard
						title={i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.title")}
						description={
							<>
								{i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.description")}
							</>
						}
						style={{ minWidth: "300px", padding: "15px 10px 10px 10px", marginTop: "10px" }}
						slotProps={{ title: { style: { color: "#42296E" } }, text: { style: { gap: "5px" } } }}
					/>
					<CorePaper
						component="section"
						sx={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "space-between",
							width: "100%",
							columnGap: "24px",
							padding: "10px",
							boxSizing: "border-box",
						}}
					>
						{content}
					</CorePaper>
				</div>
			) : (
				<>
					<ListEditTableDescription>
						{i18nPackage.t("editQuizPage.configurationStep.excludedWebTrafficRecordingUrlsListModal.description")}
					</ListEditTableDescription>
					{content}
				</>
			)}
		</CoreModal>
	);
}
